import { useState } from "react";

import { Button } from "@/components/ui/button";

import { useEntrar } from "./api";

/**
 * Entrar.
 *
 * **Una sola pantalla, sin adornos y sin menú.** Quien no ha entrado no debería ver el
 * armazón de la aplicación: enseñarle las secciones que no puede abrir no le sirve de nada
 * y le cuenta a un curioso cómo está organizado el sistema por dentro.
 *
 * **El error dice lo mismo para un correo que no existe y para una clave equivocada.**
 * Distinguirlos le regalaría a quien prueba una lista de correos válidos, y esa lista es
 * media contraseña.
 */
export function LoginPage() {
  const entrar = useEntrar();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  return (
    <main className="grid min-h-dvh place-items-center px-4 py-10">
      <form
        onSubmit={(e) => {
          e.preventDefault();
          entrar.mutate({ email: email.trim(), password });
        }}
        className="panel flex w-full max-w-sm flex-col gap-4 p-6 sm:p-8"
      >
        <header>
          <h1 className="text-2xl font-medium tracking-tight text-ink">NECA S.A.S.</h1>
          <p className="mt-1 text-sm text-ink-2">Entra para ver la planta.</p>
        </header>

        <label className="flex flex-col gap-1">
          <span className="text-xs tracking-wide text-ink-3 uppercase">Correo</span>
          <input
            id="login-email"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="h-10 rounded-md border border-line bg-surface-2 px-3 text-sm text-ink"
          />
        </label>

        <label className="flex flex-col gap-1">
          <span className="text-xs tracking-wide text-ink-3 uppercase">Contraseña</span>
          <input
            id="login-password"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="h-10 rounded-md border border-line bg-surface-2 px-3 text-sm text-ink"
          />
        </label>

        <Button type="submit" disabled={entrar.isPending}>
          {entrar.isPending ? "Entrando…" : "Entrar"}
        </Button>

        {entrar.isError ? (
          <p role="alert" className="text-sm text-bad">
            {(entrar.error as Error).message}
          </p>
        ) : null}
      </form>
    </main>
  );
}
